import React from 'react';
import { ShieldCheck, Target, Headphones, Lock, Smartphone, Instagram, Youtube, Facebook, Twitter, Linkedin, Play } from 'lucide-react';
import './BottomCTA.css';

const BottomCTA = () => {
  return (
    <div className="bottom-section-wrapper">
      
      {/* 1. CTA Banner */}
      <section className="bottom-cta-banner">
        <div className="cta-content">
          <h2 className="cta-title">Ready to take the next step in your journey?</h2>
          <p className="cta-desc">Create your profile, explore opportunities and get discovered today!</p>
        </div>
        <div className="cta-buttons">
          <button className="btn-solid red-btn ">Create Free Profile</button>
          <button className="btn-outline">Browse Auditions</button>
          <button className="btn-solid purple-btn d-none">
            Explore Discovery<br/>Experiences
          </button>
        </div>
      </section>

      {/* 2. Trust Strip */}
      <section className="bottom-trust-strip">
        <div className="trust-item">
          <span className="icon"><ShieldCheck size={28} strokeWidth={1.5} /></span>
          <div className="text">
            <strong>Verified Opportunities</strong>
            <span>100% Genuine</span>
          </div>
        </div>
        
        <div className="trust-divider"></div>

        <div className="trust-item">
          <span className="icon"><Target size={28} strokeWidth={1.5} /></span>
          <div className="text">
            <strong>Refund Guarantee</strong>
            <span>If Cancelled / No-Show</span>
          </div>
        </div>

        <div className="trust-divider"></div>

        <div className="trust-item">
          <span className="icon"><Headphones size={28} strokeWidth={1.5} /></span>
          <div className="text">
            <strong>24/7 Support</strong>
            <span>We're Here to Help</span>
          </div>
        </div>

        <div className="trust-divider"></div>

        <div className="trust-item">
          <span className="icon"><Lock size={28} strokeWidth={1.5} /></span>
          <div className="text">
            <strong>Secure Payments</strong>
            <span>Safe & Encrypted</span>
          </div>
        </div>

        <div className="trust-divider"></div>

        <div className="trust-item">
          <span className="icon"><Smartphone size={28} strokeWidth={1.5} /></span>
          <div className="text">
            <strong>Mobile Friendly</strong>
            <span>Anytime, Anywhere</span>
          </div>
        </div>
      </section>

    </div>
  );
};

export default BottomCTA;
